import React, { useCallback, useEffect, useState } from 'react';
import FJIconButton from '../../../common/components/FJIconButton/FJIconButton.jsx';
import FJLocalStore from '../../../store/FJLocalStore.js';
import DownloadIcon from '../../../assets/svg/download_black.svg?react';
import AddMediaIcon from '../../../assets/svg/add-to-media.svg?react';
import ApplyIcon from '../../../assets/svg/apply.svg?react';
import styles from './FJCommonRightHeaderView.module.less';
import FJDropdownNew from '../../../common/components/FJDropDown/FJDropdownNew.jsx';
import FJUtil from '../../../util/FJUtil.js';
import PropTypes from 'prop-types';
import FJCheckBox from '../../../common/components/FJCheckBox/FJCheckBox.jsx';
import _ from 'lodash';
import FJToolTip from '../../../common/components/FJToolTip/FJToolTip.jsx';

const Item = props => {
    const { id, url, name, isSelected = false, onClick } = props;

    const _onClick = selected => {
        onClick && onClick(id, selected);
    };

    return (
        <div className={styles.item}>
            <div className={styles.item_left}>
                <div className={styles.img_box}>
                    <img className={styles.item_img} src={url} alt={''} />
                </div>
                <div className={styles.item_name}>{name}</div>
            </div>
            <FJCheckBox selected={isSelected} dataChange={_onClick} />
        </div>
    );
};

const FJCommonRightHeaderView = props => {
    const {
        list = [],
        selectedDownloadList = [],
        isDownloading = false,
        useApplyButton = false,
        onDownload,
        onAddToMediaLibrary,
        onApply,
        selectAll,
        deselectAll,
        selectItem,
        disableDownloadMultipleSource = false, // 是否禁用同时下载多个资源
    } = props;
    const isMultipleSource = list.length > 1 && !disableDownloadMultipleSource;

    // 是否显示按钮文字
    const [isNormalButton, setIsNormalButton] = useState(true);

    const _update = useCallback(() => {
        setIsNormalButton(document.body.offsetWidth >= 1400);
    }, []);

    useEffect(() => {
        _update();
        const resizeCallback = _.debounce(_update, 200, { trailing: true });
        window.addEventListener('resize', resizeCallback);
        return () => {
            window.removeEventListener('resize', resizeCallback);
        };
    }, [_update]);

    const _selectAll = isSelected => {
        if (isSelected) {
            selectAll && selectAll();
        } else {
            deselectAll && deselectAll();
        }
    };

    const _onSelectItem = (id, selected) => {
        selectItem && selectItem(id, selected);
    };

    const _isSelected = id => {
        return selectedDownloadList && selectedDownloadList.findIndex(item => item.id === id) !== -1;
    };

    const _isSelectedAll = list.every(item => _isSelected(item.id));

    const _renderOverlay = config => {
        return (
            <div className={styles.download_menu_box} ref={config.ref}>
                <div className={styles.select_images_title}>{FJLocalStore._('select-images')}</div>
                <div className={styles.menu_box}>
                    <div className={styles.select_all_box}>
                        <div className={styles.select_all_title}>
                            {FJLocalStore._('all-images') + ` (${list.length})`}
                        </div>
                        <FJCheckBox selected={_isSelectedAll} dataChange={_selectAll} />
                    </div>
                    <div className={styles.list_box}>
                        {list.map((data, i) => {
                            const { id, url, name = '' } = data;
                            const showName = name ? name : FJUtil.getFileName(url, true);

                            return (
                                <Item
                                    key={id + i}
                                    id={id}
                                    url={url}
                                    name={showName}
                                    isSelected={_isSelected(id)}
                                    onClick={_onSelectItem}
                                />
                            );
                        })}
                    </div>
                </div>
                <FJIconButton
                    textClassName={styles.button_text}
                    text={FJLocalStore._('download')}
                    isLoading={isDownloading}
                    icon={<DownloadIcon />}
                    onClick={onDownload}
                />
            </div>
        );
    };

    const _renderDownloadButton = config => {
        return config ? (
            <div onClick={config.onClick} ref={config.ref}>
                {_renderButton(
                    <FJIconButton
                        className={isNormalButton ? '' : styles.only_icon_button}
                        textClassName={styles.button_text}
                        text={isNormalButton ? FJLocalStore._('download') : ''}
                        icon={<DownloadIcon />}
                    />,
                    FJLocalStore._('download'),
                )}
            </div>
        ) : (
            _renderButton(
                <FJIconButton
                    className={isNormalButton ? '' : styles.only_icon_button}
                    textClassName={styles.button_text}
                    text={isNormalButton ? FJLocalStore._('download') : ''}
                    icon={<DownloadIcon />}
                    onClick={onDownload}
                    isLoading={isDownloading}
                />,
                FJLocalStore._('download'),
            )
        );
    };

    const _renderButton = (button, title) => {
        if (isNormalButton) return button;
        else
            return (
                <FJToolTip title={title}>
                    <div>{button}</div>
                </FJToolTip>
            );
    };

    return (
        <div className={styles.box}>
            {isMultipleSource ? (
                <FJDropdownNew
                    offsetLeft={isNormalButton ? 0 : -77}
                    isTopLayer={true}
                    offsetTop={5}
                    renderTrigger={_renderDownloadButton}
                    renderOverlay={_renderOverlay}
                />
            ) : (
                _renderDownloadButton()
            )}
            {_renderButton(
                <FJIconButton
                    className={isNormalButton ? '' : styles.only_icon_button}
                    textClassName={styles.button_text}
                    text={isNormalButton ? FJLocalStore._(useApplyButton ? 'apply' : 'add-to-media') : ''}
                    icon={useApplyButton ? <ApplyIcon /> : <AddMediaIcon />}
                    type={'gradient'}
                    onClick={useApplyButton ? onApply : onAddToMediaLibrary}
                />,
                FJLocalStore._(useApplyButton ? 'apply' : 'add-to-media'),
            )}
        </div>
    );
};

export default FJCommonRightHeaderView;

FJCommonRightHeaderView.propTypes = {
    list: PropTypes.array,
    selectedDownloadList: PropTypes.array,
    useApplyButton: PropTypes.bool,
    onDownload: PropTypes.func,
    onAddToMediaLibrary: PropTypes.func,
    onApply: PropTypes.func,
    selectAll: PropTypes.func,
    deselectAll: PropTypes.func,
    selectItem: PropTypes.func,
    isDownloading: PropTypes.bool,
    disableDownloadMultipleSource: PropTypes.bool,
};

Item.propTypes = {
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    url: PropTypes.string,
    name: PropTypes.string,
    isSelected: PropTypes.bool,
    onClick: PropTypes.func,
};
